/* OMNÉA Willkommens-Popup, Fassung 2 „Circle-Karte“ (18.10.2026) – gehört zu sections/omnea-willkommen.liquid.
   Öffnet nach X Sekunden (erst wenn Cookie-Hinweis, Schublade, Menü und Suche zu sind). Schritt 1: eine Frage (Antwort wird auf
   die Karte graviert), Schritt 2: E-Mail per Shopify-Kundenformular, Schritt 3: Karte dreht sich, 15 % frei, Rabattcode.
   Merkt sich im Browser: geschlossen (Pause in Tagen) bzw. eingetragen (nie wieder). */
(function () {
  if (customElements.get('omnea-willkommen')) return;

  var SPEICHER = 'omnea_willkommen';
  var TAG = 864e5;

  function lesen() {
    try { return JSON.parse(localStorage.getItem(SPEICHER)) || {}; } catch (e) { return {}; }
  }
  function schreiben(w) {
    try { localStorage.setItem(SPEICHER, JSON.stringify(w)); } catch (e) {}
  }
  function sitzung(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k);
      else sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function sichtbar(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
  }

  class OmneaWillkommen extends HTMLElement {
    connectedCallback() {
      this.dlg = this.querySelector('dialog');
      this.form = this.querySelector('form');
      if (!this.dlg || !this.form) return;
      this.vorher = null;
      this.cookieGesehen = false;
      this.ziel = '';
      this.zielText = '';
      this.ck = this.querySelector('[data-owp-ck]');
      this.neigen();

      this.addEventListener('click', this.klick.bind(this));
      this.form.addEventListener('submit', this.senden.bind(this));
      this.dlg.addEventListener('cancel', (e) => { e.preventDefault(); this.schliessen(true); });
      var mail = this.form.querySelector('.owp__mail');
      if (mail) mail.addEventListener('input', () => { if (mail.getAttribute('aria-invalid')) this.fehler(''); });
      // Handy (20.10.): beim Tippen macht die Karte Platz, damit Feld und Knopf über der Tastatur bleiben
      if (mail) {
        var handy = window.matchMedia('(max-width: 749px) and (pointer: coarse)');
        mail.addEventListener('focus', () => { clearTimeout(this.tippZeit); if (handy.matches) this.dlg.classList.add('is-tippen'); });
        mail.addEventListener('blur', () => { this.tippZeit = setTimeout(() => this.dlg.classList.remove('is-tippen'), 250); });
      }

      // Theme-Editor: öffnet, wenn der Abschnitt angeklickt wird – ohne Zeitschaltung und ohne Speichern.
      if (this.dataset.editor === 'true') {
        this.imEditor = true;
        if (this.dataset.editorDanke === 'true') this.danke('', true);
        document.addEventListener('shopify:section:select', (e) => { if (e.detail && e.detail.sectionId === this.dataset.section) this.oeffnen(); });
        document.addEventListener('shopify:section:deselect', (e) => { if (e.detail && e.detail.sectionId === this.dataset.section) this.schliessen(false); });
        return;
      }

      var url = new URL(window.location.href);
      var st = this.querySelector('[data-owp-status]');
      var status = st ? st.getAttribute('data-owp-status') : '';
      var unterwegs = sitzung('owp_unterwegs') === '1';

      // Rückkehr nach normalem Absenden (z. B. nach Shopifys Bot-Prüfung)
      if (unterwegs || window.location.hash === '#owp-form') {
        sitzung('owp_unterwegs', null);
        this.ziel = sitzung('owp_ziel') || '';
        this.zielText = sitzung('owp_ziel_text') || '';
        if (this.zielText) this.gravieren(this.zielText);
        if (status === 'ok') { this.danke(sitzung('owp_fuer') || '', false); this.bereit(0); return; }
        if (status === 'fehler') { this.stufe('form', false); this.bereit(0); return; }
      }

      var erzwingen = url.searchParams.get('omnea_popup') === '1';
      var w = lesen();
      if (!erzwingen) {
        if (w.dabei) return;
        if (w.zu && Date.now() - w.zu < (parseInt(this.dataset.pause, 10) || 7) * TAG) return;
        if (url.searchParams.has('customer_posted')) return; // gerade ein anderes Formular gesendet
      }
      this.bereit((parseInt(this.dataset.verzoegerung, 10) || 0) * 1000);
    }

    // Wortmarke vorladen, dann nach der Verzögerung auf einen ruhigen Moment warten
    bereit(ms) {
      var img = this.querySelector('.owp-ck__logo');
      if (img) img.loading = 'eager';
      setTimeout(() => this.warten(), ms);
    }

    frei() {
      if (document.hidden) return false;
      if (document.querySelector('dialog[open]')) return false;
      var h = document.documentElement;
      var b = document.body;
      if (h.classList.contains('osch-offen')) return false;
      if (['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop'].some((k) => b.classList.contains(k))) return false;
      if (document.querySelector('details[open] > .menu-drawer, details[open] > .search-modal, .menu-drawer-container[open]')) return false;
      // Shopify-Cookie-Hinweis (Banner oder Einstellungen) zuerst erledigen lassen.
      // Die äußeren Hüllen haben keine Höhe (Inhalt ist fixed) – deshalb die inneren Teile prüfen.
      var cookie = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__banner .shopify-pc__banner__wrapper, #shopify-pc__banner .shopify-pc__banner__body, #shopify-pc__prefs__dialog, #shopify-pc__prefs__overlay');
      for (var i = 0; i < cookie.length; i++) {
        if (sichtbar(cookie[i])) { this.cookieGesehen = true; return false; }
      }
      var a = document.activeElement;
      if (a && a !== b && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return false;
      return true;
    }

    warten() {
      if (this.dlg.open) return;
      if (!this.frei()) { setTimeout(() => this.warten(), 1200); return; }
      if (this.cookieGesehen) { this.cookieGesehen = false; setTimeout(() => this.warten(), 1500); return; } // kurz Luft nach dem Cookie-Hinweis
      var img = this.querySelector('.owp-ck__logo');
      var los = () => { if (this.frei()) this.oeffnen(); else setTimeout(() => this.warten(), 1200); };
      if (img && !img.complete && img.decode) {
        Promise.race([img.decode().catch(function () {}), new Promise(function (r) { setTimeout(r, 2500); })]).then(los);
      } else los();
    }

    oeffnen() {
      if (this.dlg.open) return;
      this.vorher = document.activeElement;
      var h = document.documentElement;
      h.style.setProperty('--owp-sb', Math.max(0, window.innerWidth - h.clientWidth) + 'px');
      h.classList.add('owp-offen');
      this.dlg.showModal();
      void this.dlg.offsetWidth;
      this.dlg.classList.add('is-offen');
      if (this.freiNachOeffnen) { this.freiNachOeffnen = false; setTimeout(() => this.freischalten(), 450); }
      var stufe = this.querySelector('.owp__stufe:not([hidden])');
      var titel = stufe && stufe.querySelector('.owp__titel');
      if (titel) titel.focus({ preventScroll: true });
    }

    schliessen(merken) {
      if (!this.dlg.open || this.zu) return;
      this.zu = true;
      if (merken && !this.imEditor) {
        var w = lesen();
        if (!w.dabei) { w.zu = Date.now(); schreiben(w); }
      }
      this.dlg.classList.remove('is-offen');
      var fertig = () => {
        this.dlg.close();
        var h = document.documentElement;
        h.classList.remove('owp-offen');
        h.style.removeProperty('--owp-sb');
        this.zu = false;
        if (this.vorher && document.contains(this.vorher) && this.vorher.focus) this.vorher.focus({ preventScroll: true });
        this.vorher = null;
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fertig();
      else setTimeout(fertig, 300);
    }

    klick(e) {
      if (e.target.closest('[data-owp-zu]')) { e.preventDefault(); this.schliessen(true); return; }
      if (e.target.closest('[data-owp-kopieren]')) { this.kopieren(); return; }
      var option = e.target.closest('[data-owp-ziel]');
      if (option) { this.waehlen(option); return; }
      if (e.target.closest('[data-owp-weiter]')) { this.stufe('form', true); return; }
      if (e.target.closest('[data-owp-zurueck]')) { this.stufe('frage', true); return; }
      var shoppen = e.target.closest('[data-owp-shoppen]');
      if (shoppen && shoppen.getAttribute('data-bleiben') === 'true') { e.preventDefault(); this.schliessen(false); }
    }

    // Schritt wechseln: nur einer sichtbar, Dialog-Beschriftung mitziehen
    stufe(name, fokus) {
      var ids = { frage: ['owp-titel', 'owp-text'], form: ['owp-titel-form', 'owp-text-form'], danke: ['owp-titel-danke', 'owp-text-danke'] };
      var ziel = null;
      this.querySelectorAll('[data-owp-stufe]').forEach(function (el) {
        var an = el.getAttribute('data-owp-stufe') === name;
        el.hidden = !an;
        el.classList.remove('is-rein');
        if (an) ziel = el;
      });
      if (!ziel) return;
      if (name !== 'form') this.dlg.classList.remove('is-tippen');
      void ziel.offsetWidth;
      ziel.classList.add('is-rein');
      this.dlg.setAttribute('aria-labelledby', ids[name][0]);
      this.dlg.setAttribute('aria-describedby', ids[name][1]);
      if (!fokus || !this.dlg.open) return;
      var mail = this.form.querySelector('.owp__mail');
      // Am Computer gleich ins E-Mail-Feld, am Handy nicht (sonst springt die Tastatur auf)
      if (name === 'form' && mail && window.matchMedia('(pointer: fine)').matches) mail.focus({ preventScroll: true });
      else { var t = ziel.querySelector('.owp__titel'); if (t) t.focus({ preventScroll: true }); }
    }

    // Schritt 1: Antwort wählen → auf die Karte gravieren → weiter zur E-Mail
    waehlen(knopf) {
      if (this.laeuftWahl) return;
      this.querySelectorAll('[data-owp-ziel]').forEach(function (b) { b.setAttribute('aria-pressed', b === knopf ? 'true' : 'false'); });
      this.ziel = knopf.getAttribute('data-owp-ziel') || '';
      this.zielText = (knopf.textContent || '').trim();
      sitzung('owp_ziel', this.ziel);
      sitzung('owp_ziel_text', this.zielText);
      this.gravieren(this.zielText);
      this.laeuftWahl = true;
      var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(() => { this.laeuftWahl = false; this.stufe('form', true); }, ruhig ? 150 : 750);
    }

    // Text Buchstabe für Buchstabe auf die Karte „gravieren“
    gravieren(text) {
      var b = this.querySelector('[data-owp-gravur]');
      if (!b) return;
      b.textContent = '';
      b.setAttribute('aria-label', text);
      Array.from(text).forEach(function (z, i) {
        var s = document.createElement('span');
        s.textContent = z === ' ' ? '\u00a0' : z;
        s.style.animationDelay = (i * 55) + 'ms';
        b.appendChild(s);
      });
    }

    // Karte neigt sich mit der Maus (nur Maus/Stift, nicht beim Wischen)
    neigen() {
      var buehne = this.querySelector('[data-owp-buehne]');
      var innen = this.querySelector('.owp-ck__in');
      if (!buehne || !innen || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      buehne.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var r = buehne.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        innen.style.setProperty('--owp-ry', (x * 18).toFixed(2) + 'deg');
        innen.style.setProperty('--owp-rx', (-y * 14).toFixed(2) + 'deg');
      });
      buehne.addEventListener('pointerleave', function () {
        innen.style.setProperty('--owp-ry', '0deg');
        innen.style.setProperty('--owp-rx', '0deg');
      });
    }

    // Schritt 3: Karte dreht sich einmal und schaltet die 15 % frei
    freischalten() {
      if (!this.ck) return;
      var seit = this.querySelector('[data-owp-seit]');
      if (seit) {
        var d = new Date();
        seit.textContent = String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear();
      }
      if (!this.zielText) { var g = this.querySelector('[data-owp-gravur]'); if (g && /—/.test(g.textContent)) this.gravieren('Disziplin'); }
      this.ck.classList.remove('is-dreh');
      void this.ck.offsetWidth;
      this.ck.classList.add('is-frei', 'is-dreh');
    }

    fehler(text) {
      var f = this.querySelector('[data-owp-fehler]');
      var mail = this.form.querySelector('.owp__mail');
      if (!f) return;
      f.textContent = text;
      f.hidden = !text;
      if (mail) {
        if (text) mail.setAttribute('aria-invalid', 'true');
        else mail.removeAttribute('aria-invalid');
      }
    }

    laden(an) {
      var knopf = this.form.querySelector('[data-owp-senden]');
      this.laeuft = an;
      if (!knopf) return;
      if (an) { knopf.dataset.text = knopf.textContent; knopf.textContent = 'Einen Moment …'; knopf.disabled = true; }
      else { if (knopf.dataset.text) knopf.textContent = knopf.dataset.text; knopf.disabled = false; }
      this.form.setAttribute('aria-busy', an ? 'true' : 'false');
    }

    senden(e) {
      e.preventDefault();
      if (this.laeuft) return;
      var mail = this.form.querySelector('.owp__mail');
      var wert = (mail.value || '').trim();
      mail.value = wert;
      if (!wert || !mail.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert)) {
        this.fehler('Bitte gib eine gültige E-Mail-Adresse ein.');
        mail.focus();
        return;
      }
      this.fehler('');

      var fuer = this.form.querySelector('input[name="owp_fuer"]:checked');
      var fuerWert = fuer ? fuer.value : '';
      var tags = this.form.querySelector('[data-owp-tags]');
      if (tags) tags.value = (tags.getAttribute('data-basis') || '') + (this.ziel ? ', trainiert-' + this.ziel : '') + (fuerWert ? ', shoppt-' + fuerWert : '');
      sitzung('owp_fuer', fuerWert);

      if (this.imEditor) { this.danke(fuerWert, true); return; }

      this.laden(true);
      var daten = new FormData(this.form);
      daten.delete('owp_fuer');
      fetch(this.form.getAttribute('action') || '/contact', { method: 'POST', body: daten, credentials: 'same-origin' })
        .then((r) => {
          var ziel = r.url || '';
          if (/customer_posted=true/.test(ziel)) return 'ok';
          if (/\/challenge/.test(ziel)) return 'pruefung';
          return r.text().then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var st = doc.querySelector('#owp-form [data-owp-status]');
            if (st && st.getAttribute('data-owp-status') === 'ok') return 'ok';
            if (st && st.getAttribute('data-owp-status') === 'fehler') return 'fehler';
            return 'normal';
          });
        })
        .catch(function () { return 'normal'; })
        .then((ergebnis) => {
          if (ergebnis === 'ok') { this.laden(false); this.danke(fuerWert, false); return; }
          if (ergebnis === 'fehler') { this.laden(false); this.fehler('Das hat leider nicht geklappt. Bitte prüf deine E-Mail-Adresse.'); mail.focus(); return; }
          // Bot-Prüfung oder unklar: normal absenden, nach der Rückkehr zeigt das Popup den Code
          sitzung('owp_unterwegs', '1');
          HTMLFormElement.prototype.submit.call(this.form);
        });
    }

    danke(fuer, vorschau) {
      var code = this.dataset.code || '';
      if (!vorschau) {
        var w = lesen();
        w.dabei = Date.now();
        delete w.zu;
        schreiben(w);
        // Code gleich im Shop hinterlegen (Cookie), damit er an der Kasse automatisch abgezogen wird
        if (code) fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {});
      }
      var link = this.querySelector('[data-owp-shoppen]');
      if (link && code) {
        if (this.dataset.start === 'true') {
          var ziel = fuer === 'herren' ? '/collections/herren' : fuer === 'damen' ? '/collections/damen' : (link.getAttribute('href') || '/collections/all');
          link.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ziel);
          link.removeAttribute('data-bleiben');
        } else {
          link.textContent = 'Weiter shoppen';
          link.setAttribute('data-bleiben', 'true');
          link.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
      }
      this.stufe('danke', true);
      // Läuft das Popup gerade erst auf (Rückkehr nach normalem Absenden), dreht die Karte nach dem Öffnen
      if (this.dlg.open) this.freischalten();
      else this.freiNachOeffnen = true;
    }

    kopieren() {
      var code = this.dataset.code || '';
      var knopf = this.querySelector('[data-owp-kopieren]');
      var fertig = function () {
        if (!knopf) return;
        knopf.textContent = 'Kopiert';
        knopf.classList.add('is-kopiert');
        setTimeout(function () { knopf.textContent = 'Kopieren'; knopf.classList.remove('is-kopiert'); }, 2200);
      };
      var ersatz = () => {
        var wert = this.querySelector('[data-owp-code]');
        if (!wert) return;
        var r = document.createRange();
        r.selectNodeContents(wert);
        var s = window.getSelection();
        s.removeAllRanges();
        s.addRange(r);
        try { document.execCommand('copy'); fertig(); } catch (e) {}
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(fertig, ersatz);
      else ersatz();
    }
  }

  customElements.define('omnea-willkommen', OmneaWillkommen);
})();
